
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getVolumeNprofit","getNotifications","getPortfolio","getBotNotifications","getFilledOrders","getMarketData"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "f447112138688d25216b.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			